function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/\./g, '-')            // Replace . with -
    .replace(/\//g, '-')            // Replace / with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')        // Replace multiple - with single -
    .replace(/-+$/, '');            // Remove trailing dash from end of string
}

module.exports = slugify;
